import styled from 'styled-components';

export const Value = styled.div`
  padding: 1.5rem 1rem 0.5rem;
  line-height: 1;
`;
